import { Component, inject } from '@angular/core';

import { SurveyEditorService } from '../../../services/survey-editor.service';

@Component({
  selector: 'empathy-list-sources',
  templateUrl: 'list-sources.component.html',
  styleUrls: ['./list-sources.component.scss']
})
export class ListSourcesComponent {
  sources = inject(SurveyEditorService).surveyEditor$().sources;
}
